import { render } from "./AppNyilatkozat.vue?vue&type=template&id=3fbe0c73&scoped=true"
import script from "./AppNyilatkozat.vue?vue&type=script&lang=js"
export * from "./AppNyilatkozat.vue?vue&type=script&lang=js"

import "./AppNyilatkozat.vue?vue&type=style&index=0&id=3fbe0c73&scoped=true&lang=css"

import exportComponent from "F:\\repos\\ideahonlapom\\gombavezetes\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fbe0c73"]])

export default __exports__